import styled from 'styled-components';

import { colors } from '../constants';

// Block of centered, light-gray text
const SubHeading = styled.p`
  margin: 0 0 1.25rem;
  line-height: 1.75rem;
  font-size: 1rem;
  text-align: center;
  color: ${colors.TEXT_PRIMARY};
`;
SubHeading.displayName = 'SubHeading';

export default SubHeading;
